import React from "react";
import ContentPage, { Block, BulletList } from "../components/ContentPage";
import StoreBadges from "../components/StoreBadges";

export default function AppPage() {
  return (
    <ContentPage
      title="Download de Suriwebwinkel-app"
      lead="Met de Suriwebwinkel-app kun je nog gemakkelijker bestellen en je bestellingen volgen."
      ctaLabel={null}
    >
      <Block title="In de app kun je">
        <BulletList
          items={[
            "Producten bekijken",
            "Familieleden en adressen opslaan",
            "Verlanglijsten ontvangen",
            "Eerdere bestellingen opnieuw plaatsen",
            "Favoriete producten bewaren",
            "Bezorgupdates ontvangen",
            "Contact opnemen met de klantenservice",
            "Aanbiedingen en nieuwe pakketten bekijken",
          ]}
        />
        <div className="lp-about-visual" style={{ marginTop: 28 }}>
          <img src="/images/app-icon.png" alt="Suriwebwinkel app" />
        </div>
        <div style={{ marginTop: 28 }}>
          <StoreBadges />
        </div>
      </Block>
    </ContentPage>
  );
}
